import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'community',
      method: 'get',
      request: tag => ({ url: apiRoutes.communities(tag) }),
    },
  ])(ComposedComponent);
